import { createBrowserRouter, createRoutesFromElements, Route } from 'react-router-dom';

import { CareerReadinessPage } from '../../pages/CareerReadiness';
import { EmploymentReadinessPage } from '../../pages/EmploymentReadiness';
import { ExperiencePage } from '../../pages/Experience';
import { IntakePage } from '../../pages/Intake';
import Landing from '../../pages/Landing';
import { Login } from '../../pages/Login';
import { Signup } from '../../pages/Signup';
import { SkillsPage } from '../../pages/Skills';
import { StartPage } from '../../pages/Start';
import { SWOTPage } from '../../pages/SWOT';
import Layout from '../Layout/Layout';

const AppRouter = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/" element={<Layout />}>
        <Route index path="" element={<Landing />} />
        <Route index path="/pre-employment" element={<Landing />} />
        <Route index path="/signup" element={<Signup />} />
        <Route index path="/login" element={<Login />} />
        <Route index path="/pre-employment/start" element={<StartPage />} />
        <Route path="/pre-employment/intake" Component={IntakePage} />
        <Route path="/pre-employment/intake/:componentName" Component={IntakePage} />
        <Route path="/pre-employment/employment-readiness" Component={EmploymentReadinessPage} />
        <Route
          path="/pre-employment/employment-readiness/:componentName"
          Component={EmploymentReadinessPage}
        />
        <Route path="/pre-employment/skills" Component={SkillsPage} />
        <Route path="/pre-employment/skills/:componentName" Component={SkillsPage} />
        <Route path="/pre-employment/career-readiness" Component={CareerReadinessPage} />
        <Route
          path="/pre-employment/career-readiness/:componentName"
          Component={CareerReadinessPage}
        />
        <Route path="/pre-employment/experience" Component={ExperiencePage} />
        <Route path="/pre-employment/experience/:componentName" Component={ExperiencePage} />
        <Route path="/swot" Component={SWOTPage} />
        <Route path="/swot/:componentName" Component={SWOTPage} />
      </Route>
    </>,
  ),
);

export default AppRouter;
